<template>
	<div class="page-content">
  <script data-n-head="true" type="application/ld+json">{
	  "@context":"http://schema.org",
	  "@type":"BreadcrumbList","itemListElement":[
		  {
			  "@type":"ListItem",
			  "position":1,
			  "item":"https://GameEnable.com/article/","name":"Articles"
		  },
		  {
			  "@type":"ListItem",
			  "position":2,
			  "item":"https://GameEnable.com/article/{{id}}","name":"{{title}}"
		  }
	  ]
  }</script>
		 	<v-card style="margin-top:10px;">

			  <v-card-title style="font-size: 26px; " class="text-action">{{title}}</v-card-title>




    <v-card-text class="text--primary" style="padding:0 40px;" ><br>
   			<span v-html="$t('blog.howToAccessFromiOSBlogContent_1')"></span>



		<br><br><br><br>
       <h2 style="    margin-bottom: 25px;"><span v-html="$t('blog.howToAccessFromiOSBlogContent_2')"></span></h2>

		<span v-html="$t('blog.howToAccessFromiOSBlogContent_3')"></span>
		<br><br>
		<div style="">

			<v-tabs v-model="selectedContentType_first">
				<v-tab>Video</v-tab>
				<v-tab>Text</v-tab>
			</v-tabs>
			<v-tabs-items v-model="selectedContentType_first">
				<v-tab-item>

					<v-card>
						<v-card-text>
							<v-col style="position:relative;margin:0 auto;" lg="6" md="6" sm="12">
								<v-card
										class="mx-auto"

								>
									<iframe height="200"
											:src="'https://www.youtube.com/embed/uZq7XPPcUAU'"
											style="width:100%" frameborder="0"
											allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
											allowfullscreen></iframe>

									<v-card-title>
										<span v-html="$t('account.tutorials_2_Title')"></span>
									</v-card-title>

									<v-card-subtitle>
										<span v-html="$t('account.tutorials_2_Description')"></span>
									</v-card-subtitle>

								</v-card>
							</v-col>
						</v-card-text>
					</v-card>

				</v-tab-item>
				<v-tab-item>

					<v-stepper v-model="e6" vertical>
						<v-stepper-step

								step="1"
						>
							<span v-html="$t('blog.howToAccessFromiOSBlogContent_4')"></span>
						</v-stepper-step>

						<v-stepper-content step="10"></v-stepper-content>


						<v-stepper-step step="2"
						>
							<span v-html="$t('blog.howToAccessFromiOSBlogContent_5')"></span>
						</v-stepper-step>

						<v-stepper-content step="10">

							<v-img
									alt="Click on the avatar on the top right of the screen"
									class="shrink mr-2 step-image"
									contain
									src="../../assets/articles/how-to-access-stadia-from-unsupported-country-on-chrome-iphone-ipad-or-apple-tv/step1.png"
									transition="scale-transition"
									width="700px"

							/>

						</v-stepper-content>



						<v-stepper-step step="3" >
							<span v-html="$t('blog.howToAccessFromiOSBlogContent_6')"></span>
						</v-stepper-step>

						<v-stepper-content step="10">

							<v-img
									alt="Click on the avatar on the top right of the screen"
									class="shrink mr-2 step-image"
									contain
									src="../../assets/articles/how-to-access-stadia-from-unsupported-country-on-chrome-iphone-ipad-or-apple-tv/step2.png"
									transition="scale-transition"
									width="700px"

							/>

						</v-stepper-content>

						<v-stepper-step step="4" >
							<span v-html="$t('blog.howToAccessFromiOSBlogContent_7')"></span>
						</v-stepper-step>

						<v-stepper-content step="10">

							<v-img
									alt="Click on the avatar on the top right of the screen"
									class="shrink mr-2 step-image"
									contain
									src="../../assets/articles/how-to-access-stadia-from-unsupported-country-on-chrome-iphone-ipad-or-apple-tv/step3.png"
									transition="scale-transition"
									width="700px"

							/>

						</v-stepper-content>

						<v-stepper-step step="5" >
							<span v-html="$t('blog.howToAccessFromiOSBlogContent_8')"></span>
						</v-stepper-step>

						<v-stepper-content step="10">

							<v-img
									alt="Click on the avatar on the top right of the screen"
									class="shrink mr-2 step-image"
									contain
									src="../../assets/articles/how-to-access-stadia-from-unsupported-country-on-chrome-iphone-ipad-or-apple-tv/step4.png"
									transition="scale-transition"
									width="700px"

							/>

						</v-stepper-content>



					</v-stepper>





				</v-tab-item>
			</v-tabs-items>
			<br><br>
			<v-alert
					icon="mdi-information-outline"


					outlined
					type="info"
			>
				<span v-html="$t('blog.howToAccessFromiOSBlogContent_9')"></span>
			</v-alert>


		</div>
		<br><br>
		<h2 style="    margin-bottom: 25px;"><span v-html="$t('blog.howToAccessFromiOSBlogContent_10')"></span></h2>

		<span v-html="$t('blog.howToAccessFromiOSBlogContent_11')"></span>
		<br><br>
		<div style="">

			<v-tabs v-model="selectedContentType_second">

				<v-tab style="display:none;">Text</v-tab>
			</v-tabs>
			<v-tabs-items v-model="selectedContentType_second">
				<v-tab-item>

					<v-stepper
							v-model="e6"
							vertical
					>
						<v-stepper-step

								step="1"
						>
							<span v-html="$t('blog.howToAccessFromiOSBlogContent_12')"></span>
						</v-stepper-step>

						<v-stepper-content step="10">
							<v-img
									alt="Click on the avatar on the top right of the screen"
									class="shrink mr-2 step-image"
									contain
									src="../../assets/articles/settings-dns-on-iphone-or-ipad-device/step1.png"
									transition="scale-transition"
									height="350px"
									width="190px"
									style="display: inline-block;"

							/>

						</v-stepper-content>


						<v-stepper-step step="2"
						>
							<span v-html="$t('blog.howToAccessFromiOSBlogContent_13')"></span>
						</v-stepper-step>

						<v-stepper-content step="10">
							<v-img
									alt="Click on the avatar on the top right of the screen"
									class="shrink mr-2 step-image"
									contain
									src="../../assets/articles/settings-dns-on-iphone-or-ipad-device/step2.png"
									transition="scale-transition"
									height="350px"
									width="190px"
									style="display: inline-block;"

							/>
						</v-stepper-content>



						<v-stepper-step step="3" >
							<span v-html="$t('blog.howToAccessFromiOSBlogContent_14')"></span>
						</v-stepper-step>

						<v-stepper-content step="10">
							<v-img
									alt="Click on the avatar on the top right of the screen"
									class="shrink mr-2 step-image"
									contain
									src="../../assets/articles/settings-dns-on-iphone-or-ipad-device/step3.png"
									transition="scale-transition"
									height="350px"
									width="190px"

							/>
						</v-stepper-content>

						<v-stepper-step step="4" >
							<span v-html="$t('blog.howToAccessFromiOSBlogContent_15')"></span>
						</v-stepper-step>

						<v-stepper-content step="10">
							<v-img
									alt="Click on the avatar on the top right of the screen"
									class="shrink mr-2 step-image"
									contain
									src="../../assets/articles/settings-dns-on-iphone-or-ipad-device/step4.png"
									transition="scale-transition"
									height="350px"
									width="190px"

							/>
						</v-stepper-content>

						<v-stepper-step step="5" >
							<span v-html="$t('blog.howToAccessFromiOSBlogContent_16')"></span>
						</v-stepper-step>

						<v-stepper-content step="10">
							<v-img
									alt="Click on the avatar on the top right of the screen"
									class="shrink mr-2 step-image"
									contain
									src="../../assets/articles/settings-dns-on-iphone-or-ipad-device/step5.png"
									transition="scale-transition"
									height="350px"
									width="190px"
									style="position:relative;"
							/>

							<dns-ip-list style="max-width: 475px; float: none; margin-bottom: 20px; position: relative; left: 198px; margin-top: 5px; display: inline-block; top: -353px;"></dns-ip-list>
						</v-stepper-content>



					</v-stepper>





				</v-tab-item>


			</v-tabs-items>
			<br><br>
			<v-alert

					prominent
					text
					type="success"
			>
				<span v-html="$t('blog.howToAccessFromiOSBlogContent_18')"></span>
			</v-alert>

		</div>


    </v-card-text>

   <v-card-subtitle class="pb-0" >By GameEnable team  •  April 06, 2021  </v-card-subtitle>
		</v-card>


        </div>
</template>

<style scoped>

	.step-image{

			border:1px solid #cecece;
		border-radius:3px;

	}

	.steps-list > li{

		margin-bottom: 50px; font-weight: 500;

	}




	>>> .v-stepper__label {
		color: rgba(0, 0, 0, 0.87)!important;
	}

</style>

<script>

  import i18n from "@/i18n";
  import Page from '../../mixins/page'
  import dnsIpList from '../../components/dnsIpsList'

  export default {
    name: 'how-to-access-stadia-from-unsupported-country-on-chrome-iphone-ipad-or-apple-tv',
	  mixins: [Page],
	  data: ()=>({
		  id: 'how-to-access-stadia-from-unsupported-country-on-chrome-iphone-ipad-or-apple-tv',
		  selectedContentType_first: 'Text',
		  selectedContentType_second: 'Text',
		  e6:10
	  }),
	  components: {
		  dnsIpList
	  },
    computed: {
		pageTitle(){
			return i18n.t('blog.howToAccessFromiOSBlogPageTitle');
		},
		pageDescription(){
			return i18n.t('blog.howToAccessFromiOSBlogPageDescription');
		},
      title() {return i18n.t('blog.howToAccessFromiOSBlogTitle')}
    }
  };
</script>
